import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";

function Sidebar() {
    const location = useLocation();
    const [activeMenu, setActiveMenu] = useState(null);

    const toggleMenu = (menu) => {
        setActiveMenu(activeMenu === menu ? null : menu);
    };

    // Auto-open submenu based on current path
    useEffect(() => {
        const path = location.pathname;
        if (['/country', '/state', '/city'].includes(path)) setActiveMenu('location');
        else if (['/department', '/user-role', '/service-type'].includes(path)) setActiveMenu('masterSettings');
        else if (['/lead-queue', '/user-type'].includes(path)) setActiveMenu('leadSettings');
        else if (['/vendor', '/vendor-contact'].includes(path)) setActiveMenu('vendors');
        else if (path === '/dashboard') setActiveMenu('dashboard');
    }, [location.pathname]);

    const isActive = (path) => location.pathname === path ? 'active' : '';

    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu" className="sidebar-menu">
                    <ul className="sidebar-vertical">

                        {/* ── Main ── */}
                        <li className="menu-title"><span>Main</span></li>
                        <li className={`submenu ${activeMenu === 'dashboard' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('dashboard'); }}>
                                <i className="fe fe-home"></i>
                                <span>Dashboard</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'dashboard' ? 'block' : 'none' }}>
                                <li>
                                    <Link to="/dashboard" className={isActive('/dashboard')}>Admin Dashboard</Link>
                                </li>
                            </ul>
                        </li>
                        <li className={`submenu ${activeMenu === 'applications' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('applications'); }}>
                                <i className="fe fe-grid"></i>
                                <span>Applications</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'applications' ? 'block' : 'none' }}>
                                <li><a href="chat.html">Chat</a></li>
                                <li><a href="calendar.html">Calendar</a></li>
                                <li><a href="inbox.html">Email</a></li>
                            </ul>
                        </li>

                        {/* ── Lead ── */}
                        <li className="menu-title"><span>Lead</span></li>
                        <li>
                            <a href="/lead" className={isActive('/lead')}>
                                <i className="fe fe-target"></i>
                                <span>Leads</span>
                            </a>
                        </li>

                        {/* ── Vendors ── */}
                        <li className="menu-title"><span>Vendors</span></li>
                        <li className={`submenu ${activeMenu === 'vendors' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('vendors'); }}>
                                <i className="fe fe-briefcase"></i>
                                <span>Vendors</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'vendors' ? 'block' : 'none' }}>
                                <li>
                                    <a href="/vendor" className={isActive('/vendor')}>Vendor List</a>
                                </li>
                                <li>
                                    <a href="/vendor-contact" className={isActive('/vendor-contact')}>Vendor Contacts</a>
                                </li>
                            </ul>
                        </li>

                        {/* ── Extra Settings ── */}
                        <li className="menu-title"><span>Extra Settings</span></li>

                        {/* Location Master */}
                        <li className={`submenu ${activeMenu === 'location' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('location'); }}>
                                <i className="fe fe-map-pin"></i>
                                <span>Location Master</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'location' ? 'block' : 'none' }}>
                                <li><a href="/country" className={isActive('/country')}>Country</a></li>
                                <li><a href="/state" className={isActive('/state')}>State</a></li>
                                <li><a href="/city" className={isActive('/city')}>City</a></li>
                            </ul>
                        </li>

                        {/* Master Settings */}
                        <li className={`submenu ${activeMenu === 'masterSettings' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('masterSettings'); }}>
                                <i className="fe fe-settings"></i>
                                <span>Master Settings</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'masterSettings' ? 'block' : 'none' }}>
                                <li><a href="/department" className={isActive('/department')}>Department</a></li>
                                <li><a href="/user-roll" className={isActive('/user-roll')}>User Role</a></li>
                                <li><a href="/service-type" className={isActive('/service-type')}>Service Type</a></li>
                            </ul>
                        </li>

                        {/* Lead Settings */}
                        <li className={`submenu ${activeMenu === 'leadSettings' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('leadSettings'); }}>
                                <i className="fe fe-sliders"></i>
                                <span>Lead Settings</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'leadSettings' ? 'block' : 'none' }}>
                                <li><a href="/lead-queue" className={isActive('/lead-queue')}>Lead Queue</a></li>
                                <li><a href="/user-type" className={isActive('/user-type')}>User Type</a></li>
                            </ul>
                        </li>

                        {/* ── Users ── */}
                        <li className="menu-title"><span>Users</span></li>
                        <li>
                            <a href="/user" className={isActive('/user')}>
                                <i className="fe fe-user"></i>
                                <span>Users</span>
                            </a>
                        </li>

                        {/* ── Settings ── */}
                        <li className="menu-title"><span>Settings</span></li>
                        <li>
                            <a href="/settings" className={isActive('/settings')}>
                                <i className="fe fe-tool"></i>
                                <span>Settings</span>
                            </a>
                        </li>

                        {/* ── Customers ── */}
                        <li className="menu-title"><span>Customers</span></li>
                        <li>
                            <a href="/employee" className={isActive('/employee')}>
                                <i className="fe fe-users"></i>
                                <span>Employee</span>
                            </a>
                        </li>
                        <li>
                            <a href="/product" className={isActive('/product')}>
                                <i className="fe fe-package"></i>
                                <span>Product</span>
                            </a>
                        </li>
                        <li>
                            <a href="/customer" className={isActive('/customer')}>
                                <i className="fe fe-user-check"></i>
                                <span>Customers</span>
                            </a>
                        </li>

                        {/* ── Inventory ── */}
                        <li className="menu-title"><span>Inventory</span></li>
                        <li className={`submenu ${activeMenu === 'inventory' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('inventory'); }}>
                                <i className="fe fe-package"></i>
                                <span>Products / Services</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'inventory' ? 'block' : 'none' }}>
                                <li><a href="product-list.html">Product List</a></li>
                                <li><a href="category.html">Category</a></li>
                                <li><a href="units.html">Units</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="inventory.html">
                                <i className="fe fe-archive"></i>
                                <span>Inventory</span>
                            </a>
                        </li>

                        {/* ── Signature ── */}
                        <li className="menu-title"><span>Signature</span></li>
                        <li>
                            <a href="signature-list.html">
                                <i className="fe fe-clipboard"></i>
                                <span>List of Signature</span>
                            </a>
                        </li>
                        <li>
                            <a href="signature-invoice.html">
                                <i className="fe fe-box"></i>
                                <span>Signature Invoice</span>
                            </a>
                        </li>

                        {/* ── Sales ── */}
                        <li className="menu-title"><span>Sales</span></li>
                        <li className={`submenu ${activeMenu === 'invoices' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('invoices'); }}>
                                <i className="fe fe-file"></i>
                                <span>Invoices</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'invoices' ? 'block' : 'none' }}>
                                <li><a href="invoices.html">Invoices List</a></li>
                                <li><a href="invoice-details-admin.html">Invoice Details (Admin)</a></li>
                                <li><a href="invoice-details.html">Invoice Details (Customer)</a></li>
                                <li><a href="invoice-template.html">Invoice Templates</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="recurring-invoices.html">
                                <i className="fe fe-clipboard"></i>
                                <span>Recurring Invoices</span>
                            </a>
                        </li>
                        <li>
                            <a href="credit-notes.html">
                                <i className="fe fe-edit"></i>
                                <span>Credit Notes</span>
                            </a>
                        </li>

                        {/* ── Purchases ── */}
                        <li className="menu-title"><span>Purchases</span></li>
                        <li>
                            <a href="purchases.html">
                                <i className="fe fe-shopping-cart"></i>
                                <span>Purchases</span>
                            </a>
                        </li>
                        <li>
                            <a href="purchase-orders.html">
                                <i className="fe fe-shopping-bag"></i>
                                <span>Purchase Orders</span>
                            </a>
                        </li>
                        <li>
                            <a href="debit-notes.html">
                                <i className="fe fe-file-text"></i>
                                <span>Debit Notes</span>
                            </a>
                        </li>

                        {/* ── Finance & Accounts ── */}
                        <li className="menu-title"><span>Finance &amp; Accounts</span></li>
                        <li>
                            <a href="expenses.html">
                                <i className="fe fe-file-plus"></i>
                                <span>Expenses</span>
                            </a>
                        </li>
                        <li>
                            <a href="payments.html">
                                <i className="fe fe-credit-card"></i>
                                <span>Payments</span>
                            </a>
                        </li>

                        {/* ── Quotations ── */}
                        <li className="menu-title"><span>Quotations</span></li>
                        <li>
                            <a href="quotations.html">
                                <i className="fe fe-clipboard"></i>
                                <span>Quotations</span>
                            </a>
                        </li>
                        <li>
                            <a href="delivery-challans.html">
                                <i className="fe fe-file-text"></i>
                                <span>Delivery Challans</span>
                            </a>
                        </li>

                        {/* ── Reports ── */}
                        <li className="menu-title"><span>Reports</span></li>
                        <li>
                            <a href="payment-summary.html">
                                <i className="fe fe-credit-card"></i>
                                <span>Payment Summary</span>
                            </a>
                        </li>
                        <li className={`submenu ${activeMenu === 'reports' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('reports'); }}>
                                <i className="fe fe-box"></i>
                                <span>Reports</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'reports' ? 'block' : 'none' }}>
                                <li><a href="expense-report.html">Expense Report</a></li>
                                <li><a href="purchase-report.html">Purchase Report</a></li>
                                <li><a href="purchase-return.html">Purchase Return Report</a></li>
                                <li><a href="sales-report.html">Sales Report</a></li>
                                <li><a href="sales-return-report.html">Sales Return Report</a></li>
                                <li><a href="quotation-report.html">Quotation Report</a></li>
                                <li><a href="payment-report-2.html">Payment Report</a></li>
                                <li><a href="stock-report.html">Stock Report</a></li>
                                <li><a href="low-stock-report.html">Low Stock Report</a></li>
                                <li><a href="income-report.html">Income Report</a></li>
                                <li><a href="tax-purchase.html">Tax Report</a></li>
                                <li><a href="profit-loss-list.html">Profit &amp; Loss</a></li>
                            </ul>
                        </li>

                        {/* ── User Management ── */}
                        <li className="menu-title"><span>User Management</span></li>
                        <li>
                            <a href="users.html">
                                <i className="fe fe-user"></i>
                                <span>Users</span>
                            </a>
                        </li>
                        <li>
                            <a href="roles-permission.html">
                                <i className="fe fe-clipboard"></i>
                                <span>Roles &amp; Permission</span>
                            </a>
                        </li>
                        <li>
                            <a href="delete-account-request.html">
                                <i className="fe fe-trash-2"></i>
                                <span>Delete Account Request</span>
                            </a>
                        </li>

                        {/* ── Membership ── */}
                        <li className="menu-title"><span>Membership</span></li>
                        <li className={`submenu ${activeMenu === 'membership' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('membership'); }}>
                                <i className="fe fe-book"></i>
                                <span>Membership</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'membership' ? 'block' : 'none' }}>
                                <li><a href="membership-plans.html">Membership Plans</a></li>
                                <li><a href="membership-addons.html">Membership Addons</a></li>
                                <li><a href="subscribers.html">Subscribers</a></li>
                                <li><a href="transactions.html">Transactions</a></li>
                            </ul>
                        </li>

                        {/* ── Content (CMS) ── */}
                        <li className="menu-title"><span>Content (CMS)</span></li>
                        <li>
                            <a href="pages.html">
                                <i className="fe fe-folder"></i>
                                <span>Pages</span>
                            </a>
                        </li>
                        <li className={`submenu ${activeMenu === 'blog' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('blog'); }}>
                                <i className="fe fe-book"></i>
                                <span>Blog</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'blog' ? 'block' : 'none' }}>
                                <li><a href="all-blogs.html">All Blogs</a></li>
                                <li><a href="categories.html">Categories</a></li>
                                <li><a href="blog-comments.html">Blog Comments</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="testimonials.html">
                                <i className="fe fe-message-square"></i>
                                <span>Testimonials</span>
                            </a>
                        </li>
                        <li>
                            <a href="faq.html">
                                <i className="fe fe-alert-circle"></i>
                                <span>FAQ</span>
                            </a>
                        </li>

                        {/* ── Support ── */}
                        <li className="menu-title"><span>Support</span></li>
                        <li>
                            <a href="contact-messages.html">
                                <i className="fe fe-printer"></i>
                                <span>Contact Messages</span>
                            </a>
                        </li>
                        <li className={`submenu ${activeMenu === 'tickets' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('tickets'); }}>
                                <i className="fe fe-save"></i>
                                <span>Tickets</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'tickets' ? 'block' : 'none' }}>
                                <li><a href="tickets.html">Tickets</a></li>
                                <li><a href="tickets-list.html">Tickets List</a></li>
                                <li><a href="tickets-kanban.html">Tickets Kanban</a></li>
                                <li><a href="ticket-details.html">Ticket Overview</a></li>
                            </ul>
                        </li>

                        {/* ── Pages ── */}
                        <li className="menu-title"><span>Pages</span></li>
                        <li>
                            <a href="profile.html">
                                <i className="fe fe-user"></i>
                                <span>Profile</span>
                            </a>
                        </li>
                        <li className={`submenu ${activeMenu === 'auth' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('auth'); }}>
                                <i className="fe fe-lock"></i>
                                <span>Authentication</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'auth' ? 'block' : 'none' }}>
                                <li><a href="login.html">Login</a></li>
                                <li><a href="register.html">Register</a></li>
                                <li><a href="forgot-password.html">Forgot Password</a></li>
                                <li><a href="lock-screen.html">Lock Screen</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="error-404.html">
                                <i className="fe fe-x-square"></i>
                                <span>Error Pages</span>
                            </a>
                        </li>
                        <li>
                            <a href="blank-page.html">
                                <i className="fe fe-file"></i>
                                <span>Blank Page</span>
                            </a>
                        </li>
                        <li>
                            <a href="maps-vector.html">
                                <i className="fe fe-image"></i>
                                <span>Vector Maps</span>
                            </a>
                        </li>

                        {/* ── UI Interface ── */}
                        <li className="menu-title"><span>UI Interface</span></li>
                        <li className={`submenu ${activeMenu === 'baseui' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('baseui'); }}>
                                <i className="fe fe-pocket"></i>
                                <span>Base UI</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'baseui' ? 'block' : 'none' }}>
                                <li><a href="alerts.html">Alerts</a></li>
                                <li><a href="accordions.html">Accordions</a></li>
                                <li><a href="avatar.html">Avatar</a></li>
                                <li><a href="badges.html">Badges</a></li>
                                <li><a href="buttons.html">Buttons</a></li>
                                <li><a href="buttongroup.html">Button Group</a></li>
                                <li><a href="breadcrumbs.html">Breadcrumb</a></li>
                                <li><a href="cards.html">Cards</a></li>
                                <li><a href="carousel.html">Carousel</a></li>
                                <li><a href="dropdowns.html">Dropdowns</a></li>
                                <li><a href="grid.html">Grid</a></li>
                                <li><a href="images.html">Images</a></li>
                                <li><a href="lightbox.html">Lightbox</a></li>
                                <li><a href="media.html">Media</a></li>
                                <li><a href="modal.html">Modals</a></li>
                                <li><a href="offcanvas.html">Offcanvas</a></li>
                                <li><a href="pagination.html">Pagination</a></li>
                                <li><a href="popover.html">Popover</a></li>
                                <li><a href="progress.html">Progress Bars</a></li>
                                <li><a href="placeholders.html">Placeholders</a></li>
                                <li><a href="rangeslider.html">Range Slider</a></li>
                                <li><a href="spinners.html">Spinner</a></li>
                                <li><a href="sweetalerts.html">Sweet Alerts</a></li>
                                <li><a href="tab.html">Tabs</a></li>
                                <li><a href="toastr.html">Toasts</a></li>
                                <li><a href="tooltip.html">Tooltip</a></li>
                                <li><a href="typography.html">Typography</a></li>
                                <li><a href="video.html">Video</a></li>
                            </ul>
                        </li>
                        <li className={`submenu ${activeMenu === 'elements' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('elements'); }}>
                                <i className="fe fe-box"></i>
                                <span>Elements</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'elements' ? 'block' : 'none' }}>
                                <li><a href="ribbon.html">Ribbon</a></li>
                                <li><a href="clipboard.html">Clipboard</a></li>
                                <li><a href="drag-drop.html">Drag &amp; Drop</a></li>
                                <li><a href="rating.html">Rating</a></li>
                                <li><a href="text-editor.html">Text Editor</a></li>
                                <li><a href="counter.html">Counter</a></li>
                                <li><a href="scrollbar.html">Scrollbar</a></li>
                                <li><a href="notification.html">Notification</a></li>
                                <li><a href="stickynote.html">Sticky Note</a></li>
                                <li><a href="timeline.html">Timeline</a></li>
                                <li><a href="horizontal-timeline.html">Horizontal Timeline</a></li>
                                <li><a href="form-wizard.html">Form Wizard</a></li>
                            </ul>
                        </li>
                        <li className={`submenu ${activeMenu === 'charts' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('charts'); }}>
                                <i className="fe fe-bar-chart"></i>
                                <span>Charts</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'charts' ? 'block' : 'none' }}>
                                <li><a href="chart-apex.html">Apex Charts</a></li>
                                <li><a href="chart-js.html">Chart Js</a></li>
                                <li><a href="chart-morris.html">Morris Charts</a></li>
                                <li><a href="chart-flot.html">Flot Charts</a></li>
                                <li><a href="chart-peity.html">Peity Charts</a></li>
                                <li><a href="chart-c3.html">C3 Charts</a></li>
                            </ul>
                        </li>
                        <li className={`submenu ${activeMenu === 'icons' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('icons'); }}>
                                <i className="fe fe-award"></i>
                                <span>Icons</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'icons' ? 'block' : 'none' }}>
                                <li><a href="icon-fontawesome.html">Fontawesome Icons</a></li>
                                <li><a href="icon-feather.html">Feather Icons</a></li>
                                <li><a href="icon-ionic.html">Ionic Icons</a></li>
                                <li><a href="icon-material.html">Material Icons</a></li>
                                <li><a href="icon-pe7.html">Pe7 Icons</a></li>
                                <li><a href="icon-simpleline.html">Simpleline Icons</a></li>
                                <li><a href="icon-themify.html">Themify Icons</a></li>
                                <li><a href="icon-weather.html">Weather Icons</a></li>
                                <li><a href="icon-typicon.html">Typicon Icons</a></li>
                                <li><a href="icon-flag.html">Flag Icons</a></li>
                            </ul>
                        </li>
                        <li className={`submenu ${activeMenu === 'forms' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('forms'); }}>
                                <i className="fe fe-sidebar"></i>
                                <span>Forms</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'forms' ? 'block' : 'none' }}>
                                <li><a href="form-basic-inputs.html">Basic Inputs</a></li>
                                <li><a href="form-input-groups.html">Input Groups</a></li>
                                <li><a href="form-horizontal.html">Horizontal Form</a></li>
                                <li><a href="form-vertical.html">Vertical Form</a></li>
                                <li><a href="form-mask.html">Form Mask</a></li>
                                <li><a href="form-validation.html">Form Validation</a></li>
                                <li><a href="form-select2.html">Form Select2</a></li>
                                <li><a href="form-fileupload.html">File Upload</a></li>
                            </ul>
                        </li>
                        <li className={`submenu ${activeMenu === 'tables' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('tables'); }}>
                                <i className="fe fe-layout"></i>
                                <span>Tables</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'tables' ? 'block' : 'none' }}>
                                <li><a href="tables-basic.html">Basic Tables</a></li>
                                <li><a href="data-tables.html">Data Table</a></li>
                            </ul>
                        </li>

                        {/* ── Settings (bottom) ── */}
                        <li className="menu-title"><span>Settings</span></li>
                        <li>
                            <a href="settings.html">
                                <i className="fe fe-settings"></i>
                                <span>Settings</span>
                            </a>
                        </li>
                        <li>
                            <a href="login.html">
                                <i className="fe fe-power"></i>
                                <span>Logout</span>
                            </a>
                        </li>

                        {/* ── Extras ── */}
                        <li className="menu-title"><span>Extras</span></li>
                        <li>
                            <a href="#">
                                <i className="fe fe-file-text"></i>
                                <span>Documentation</span>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i className="fe fe-lock"></i>
                                <span>Change Log</span>
                                <span className="badge badge-primary ms-auto">v2.0.4</span>
                            </a>
                        </li>
                        <li className={`submenu ${activeMenu === 'multilevel' ? 'subdrop' : ''}`}>
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu('multilevel'); }}>
                                <i className="fa fa-list"></i>
                                <span>Multi Level</span>
                                <span className="menu-arrow"></span>
                            </a>
                            <ul style={{ display: activeMenu === 'multilevel' ? 'block' : 'none' }}>
                                <li className="submenu">
                                    <a href="#"><span>Level 1</span><span className="menu-arrow"></span></a>
                                    <ul style={{ display: 'none' }} className="level2">
                                        <li><a href="#"><span>Level 2</span></a></li>
                                        <li className="submenu">
                                            <a href="#"><span>Level 2</span><span className="menu-arrow"></span></a>
                                            <ul style={{ display: 'none' }} className="level3">
                                                <li><a href="#">Level 3</a></li>
                                                <li><a href="#">Level 3</a></li>
                                            </ul>
                                        </li>
                                        <li><a href="#"><span>Level 2</span></a></li>
                                    </ul>
                                </li>
                                <li><a href="#"><span>Level 1</span></a></li>
                            </ul>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;